import Button from '@orn/shared-web/components/Button/Button';
import Card from '@orn/shared-web/components/Card';
import { AlertTriangleIcon } from '@orn/shared-web/icons';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { PATHS } from '../../../../paths';

import type { Callout } from '../../CalloutCard';

interface IUnverifiedPhoneCalloutCardProps {
  callout: Callout;
  onDismiss?: (appropriate?: boolean) => void;
  className?: string;
}

const UnverifiedPhoneCalloutCard = ({ onDismiss, className }: IUnverifiedPhoneCalloutCardProps) => {
  const navigate = useNavigate();

  return (
    <Card variant="error" className={className}>
      <Card.Header
        icon={<AlertTriangleIcon />}
        label="Phone not verified"
        onDismiss={onDismiss ? () => onDismiss() : undefined}
      />
      <Card.Body>
        <Card.Text>Verify your phone number to finish securing your account.</Card.Text>
        <Button
          color="primary-destructive"
          size="xs"
          className="mt-2 w-full"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            void navigate(PATHS.SETTINGS);
          }}
        >
          Verify phone
        </Button>
      </Card.Body>
    </Card>
  );
};

export default UnverifiedPhoneCalloutCard;
